import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { TableFilterMenu } from '@interxfi/design-system/components/table/filter/table-filter-menu';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import {
  type TrialBalanceFilterableField,
  TrialBalanceTable,
} from '../../../../../../../../../../features/accounting/trial-balance/trial-balance-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/trial-balance/_trial-balance/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingFinanceAccounting,
      label: 'Trial Balance',
      order: 3,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingFinanceAccounting>,
  head: () => getPageHead('Trial Balance'),
  component: AccountingTrialBalance,
});

function TableHeader({ filterProps }: CustomTableHeaderProps<TrialBalanceFilterableField>) {
  return (
    <PageTabRail
      actions={
        filterProps ? (
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            <TableFilterMenu<TrialBalanceFilterableField> {...filterProps} />
          </HorizontalStack>
        ) : null
      }
      group={TabbedNavigationGroup.ClearingFinanceAccounting}
    />
  );
}

function AccountingTrialBalance() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <TrialBalanceTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
